import { render } from "./DropdownCommittee.vue?vue&type=template&id=77e11522"
import script from "./DropdownCommittee.vue?vue&type=script&lang=ts"
export * from "./DropdownCommittee.vue?vue&type=script&lang=ts"
script.render = render

export default script